import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import {
  mainFontFamily, ssColorCyan, ssColorWhite, mediaBreakpointUpSM, mediaBreakpointUpLG,
} from '../constants/style-constants';
import { vunit } from '../lib/style-helpers';

const greetingCss = css`
  color: ${ssColorCyan};
`;

const greetingFallbackCss = css`
  color: ${ssColorCyan};
  font-size: 1.2rem;

  ${mediaBreakpointUpSM} {
    font-size: 1.5rem;
  }

  ${mediaBreakpointUpLG} {
    font-size: 2rem;
  }
`;

const greetingSalutationCss = css`
  color: ${ssColorWhite};
  font-size: 1.2rem;
  text-transform: capitalize;

  ${mediaBreakpointUpSM} {
    font-size: 1.6rem;
  }
`;

const greetingNameCss = css`
  display: block;
  font-family: ${mainFontFamily};
  font-size: 1.3rem;
  margin-top: ${vunit(1)};
  text-transform: capitalize;

  ${mediaBreakpointUpSM} {
    font-size: 1.9rem;
  }
`;

const OnboardingGreeting = ({ fullName, noFullNameFallback, salutation }) => (
  fullName ? (
    <h1 css={greetingCss}>
      <span css={greetingSalutationCss}>{salutation.toUpperCase()}</span>
      {' '}
      <span css={greetingNameCss}>{fullName}</span>
    </h1>
  ) : <h1 css={greetingFallbackCss}>{noFullNameFallback.toUpperCase()}</h1>
);

OnboardingGreeting.defaultProps = {
  fullName: null,
};

OnboardingGreeting.propTypes = {
  salutation: PropTypes.string.isRequired,
  fullName: PropTypes.string,
  noFullNameFallback: PropTypes.string.isRequired,
};

export default OnboardingGreeting;
